import React, { useState, useEffect } from 'react';
import { number, shape, node, bool, oneOf } from 'prop-types';
import { progressUnionTypes, getPercentageProgressBetweenDates } from '@paddl/utils-js';
import { TwoLineBlockProgress, OneLineSmallProgress } from './SectionsTypes';
import { getProgressIndicatorStyles } from '../../../../Utils/activities';
const calculatePercentage = _ref => {
  let {
    startDate: {
      day: startDay,
      month: startMonth,
      year: startYear
    },
    endDate: {
      day: endDay,
      month: endMonth,
      year: endYear
    }
  } = _ref;
  return getPercentageProgressBetweenDates({
    startDate: new Date(startYear, startMonth - 1, startDay),
    endDate: new Date(endYear, endMonth - 1, endDay)
  });
};
const getProgress = _ref2 => {
  let {
    startDate,
    endDate,
    isCurrent,
    percentageComplete,
    timeStamp
  } = _ref2;
  if (percentageComplete) {
    return percentageComplete;
  }
  if (timeStamp || isCurrent) {
    return 100;
  }
  return calculatePercentage({
    startDate,
    endDate
  });
};
export const ProgressSectionRead = _ref3 => {
  let {
    layout,
    progressType,
    data: {
      percentageComplete,
      duration
    } = {},
    editButton
  } = _ref3;
  const {
    startDate,
    endDate,
    isCurrent,
    timeStamp
  } = duration;
  const [progress, setProgress] = useState(0);
  const [progressIndicatorStyles, setProgressIndicatorStyles] = useState({});
  const instantProgress = getProgress({
    startDate,
    endDate,
    isCurrent,
    percentageComplete,
    timeStamp
  });
  useEffect(() => {
    setProgressIndicatorStyles(getProgressIndicatorStyles({
      progress: instantProgress,
      progressType,
      percentageComplete,
      isCurrent
    }));
    setTimeout(() => {
      setProgress(instantProgress);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return layout === 'OneLineSmallProgress' ? /*#__PURE__*/React.createElement(OneLineSmallProgress, {
    editButton: editButton,
    progress: instantProgress,
    progressIndicatorStyles: progressIndicatorStyles,
    progressType: progressType,
    duration: duration,
    "data-test-id": "one-line-small-progress"
  }) : /*#__PURE__*/React.createElement(TwoLineBlockProgress, {
    editButton: editButton,
    progress: progress,
    progressIndicatorStyles: progressIndicatorStyles,
    progressType: progressType,
    duration: duration,
    "data-test-id": "two-line-block-progress"
  });
};
ProgressSectionRead.propTypes = {
  layout: oneOf(['OneLineSmallProgress', 'TwoLineBlockProgress']),
  progressType: oneOf(progressUnionTypes).isRequired,
  data: shape({
    percentageComplete: number,
    duration: shape({
      startDate: shape({
        day: number,
        month: number,
        year: number
      }),
      endDate: shape({
        day: number,
        month: number,
        year: number
      }),
      timeStamp: shape({
        day: number,
        month: number,
        year: number
      }),
      isCurrent: bool
    }).isRequired
  }).isRequired,
  editButton: node
};
ProgressSectionRead.defaultProps = {
  editButton: undefined,
  layout: 'TwoLineBlockProgress'
};